// extracted by mini-css-extract-plugin
export default {"resetPasswordForm":"forgotpassword_resetPasswordForm__p3krP","formGroup":"forgotpassword_formGroup__6FAZd","signinForm":"forgotpassword_signinForm__hJV7H"};